import { FC } from 'react'
import { Selector, SelectorType } from './Selector'

export const Organization: FC & SelectorType = (): JSX.Element => <></>

Organization.Selector = Selector
